import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class PersonService {
    private readonly apiUrl = 'api/person';

    constructor(
        private readonly httpClient: HttpClient
    ) {
    }

    isActive(univid: string): Observable<boolean> {
        return this.httpClient.post<boolean>(`${this.apiUrl}/IsActive`, { Univid: univid });
    }

    hasPersonCompletedCashHandlingTraining(univid: string): Observable<boolean> {
        return this.httpClient.post<boolean>(`${this.apiUrl}/CashHandlingTraining`, { Univid: univid });
    }
}